var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-btn-mobile",on:{"click":function($event){return _vm.navigateTo('/')}}},[_c('img',{attrs:{"src":require("../../../../assets/images/mobile/mobile_home_icon.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }